<template>
    <div>
        <div class="main-button-bar">
            <el-button type="primary" size="small" @click="createItem">新增分销</el-button>
        </div>

        <el-table
            :data="records"
            stripe
            style="width: 100%"
            :height="this.$tools.mainHeight() - 84"
            class="taobao-dis-table"
        >
            <el-table-column prop="id" label="编号" width="200"></el-table-column>
            <el-table-column prop="" label="分类" width="200"></el-table-column>
        </el-table>

        <taobao-dis-item :show.sync="showItem"></taobao-dis-item>
    </div>
</template>

<script>
import TaobaoDisItem from './Taobao-dis-item.vue';
export default {
    components: { TaobaoDisItem },
    data() {
        return {
            records: null,
            showItem: false
        };
    },
    methods: {
        createItem() {
            this.showItem = true;
        }
    }
};
</script>

<style lang="scss">
</style>